import React, { FC, Fragment, ReactElement } from 'react'

import { Tooltip } from '../Tooltip'
import * as S from './DropDownMenu.styles'
import { DropDownMenuItemProps } from './DropDownMenu.types'

interface DropDownMenuContentProps {
  itemsToMap: DropDownMenuItemProps[]
  onClickMenu: VoidFunction
}

export const DropDownMenuContent: FC<DropDownMenuContentProps> = ({ itemsToMap, onClickMenu }) => {
  const handleClickMenuItem = (item: DropDownMenuItemProps) => {
    if (item.disabled) return
    if (item.action) item.action()
    if (item.hideOnClick === undefined || item.hideOnClick) onClickMenu()
  }

  return (
    <>
      {itemsToMap.map(item => {
        const hasTooltipContent = !!item?.tooltipContent

        const wrapper = (menuItem: ReactElement) =>
          hasTooltipContent ? (
            <Tooltip content={item?.tooltipContent} placement="right">
              <div data-cy={item.dataCy}>{menuItem}</div>
            </Tooltip>
          ) : (
            <div data-cy={item.dataCy}>{menuItem}</div>
          )

        return (
          <Fragment key={item.label}>
            {item?.customLabel
              ? item?.customLabel
              : wrapper(
                  <S.MenuItem
                    data-cy={`lh-dropdown-item-${item.label
                      .toString()
                      .toLowerCase()
                      .split(' ')
                      .join('-')}`}
                    color={item.color}
                    iconFirst={item.iconFirst}
                    disabled={item.disabled}
                    onClick={() => handleClickMenuItem(item)}
                  >
                    {item.label}
                    {item?.icon}
                  </S.MenuItem>,
                )}
          </Fragment>
        )
      })}
    </>
  )
}
